<div style="height: calc(100vh - 310px);" *ngIf="dataSource$ | async as dataSource">
  <div style="overflow: auto; height: calc(100vh - 373px); padding: 0 35px;">
    <div style="overflow: visible;" *ngIf="dataSource.data.length > 0">
      <div
           style="display: flex; justify-content: end; gap: 10px;">
        <button class="action-button" mat-button aria-label="Clear" (click)="synchronize()" *inRole="[roles.OperationsExpertFeatureSet, roles.Administrator]"
				style="transition: 350ms ease-in-out; background: #1e6500; color: #FFF; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);">
          <span class="fal fa-screwdriver-wrench"></span>
          <span style="padding-left: 10px;">Synchronize</span>
        </button>
      </div>
      <table mat-table [dataSource]="dataSource" class="table-width"
             [trackBy]="trackByFn" style="width: 100%; border-spacing: 0 3px; background: transparent;">
        <ng-container matColumnDef="selecto-checko">
          <th mat-header-cell *matHeaderCellDef style="width: 5%">
            <div class="form-control-wrapper">
              <mat-checkbox
                            [indeterminate]="selectedIds.length > 0 && selectedIds.length < dataSource.data.length"
                            [checked]="selectedIds.length === dataSource.data.length"
                            (change)="selectAll($event.checked)"></mat-checkbox>
            </div>
          </th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async">
            <div class="form-control-wrapper">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelected(element)"
                            [ngModel]="isSelected(element)"></mat-checkbox>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 14px">Status</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px;">{{element.indexHealthType === 1 ? 'Document and Index count mismatch' : 'Document and KB doc count mismatch'}}</td>
        </ng-container>
        <ng-container matColumnDef="caseName">
          <th mat-header-cell *matHeaderCellDef style="width: 18%; font-size: 14px">Case</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.name}}</td>
        </ng-container>
        <ng-container matColumnDef="docCount">
          <th mat-header-cell *matHeaderCellDef style="width: 7%; font-size: 14px">Document Count</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.documentCount}}</td>
        </ng-container>
        <ng-container matColumnDef="indexDocCount">
          <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 14px">Index Count</th>
          <td mat-cell *matCellDef="let element" [style.height.px]="rowHeight$ | async" style="font-size: 14px">{{element.indexDocCount}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr [@rowTransitionAnimation]="{ value: '', params: { delay: i * 100 } }" mat-row *matRowDef="let row; let i = index; columns:columnsToDisplay" style="cursor: pointer;" [style.height.px]="rowHeight$ | async">
        </tr>
      </table>
    </div>

    <div *ngIf="dataSource.data.length < 1">
      <div
           style="display: flex; justify-content: center; align-items: center; width: 100%; height: 450px; font-size: 20px;">
        <span class="fal fa-binary-circle-check"></span>
        <span style="padding-left: 10px;">No Index Health Issues.</span>
      </div>
    </div>
  </div>
</div>
